import {observer} from "mobx-react-lite";
import React from "react";
import {Modulator} from "../stores/Modulator";
import {ModulatorWaveBase} from "./ModulatorWaveBase";
import {ModulatorWaveDot} from "./ModulatorWaveDot";
import {ModulatorCustomValues} from "./ModulatorCustomValues";

interface ModulatorWaveProps {
    modulator: Modulator;           // "CC<CC>" by default
}

export const ModulatorWave = observer(({modulator}: ModulatorWaveProps) => {

    return (
        <div className="wave">
            <div className="wave-wrapper">
                <ModulatorWaveBase modulator={modulator} />
                <ModulatorWaveDot x={modulator.x} y={modulator.y} />
            </div>
            <ModulatorCustomValues modulator={modulator} />
        </div>
    );

});
